<script>
    import { entities } from "../../utils/NotificationStrings";
    import { actions } from "../../utils/NotificationStrings";

    export let content = {};
</script>

<p class="text-sm">
    <b>{content.user.name}</b>

    {actions[content.action]}

    {entities[content.entity.type]}

    "{content.entity.name}"
</p>
